import http from '../common/http-auth';
import httpCommon from 'src/common/http-common';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const forgotPassword = async (data: string) => {
    const response = http.post(`/authentication/forgotpassword`,  data)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const resetverifyToken = async (token: string) => {
    const response = http.post(`/authentication/verifytoken?verifyToken=${token}`)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const resetPassword = async (data: string) => {
    const response = http.post(`/authentication/passwordreset`,  data)
    return response ;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const createPassword = async (data: string) => {
    const response = httpCommon.post(`/user/createpassword`,  data)
    return response ;
}

